import seoRoutes from './seo.routes.json'

interface SeoConfig {
  title: string
  description: string
  keywords: string
  organization: {
    name: string
    description: string
  }
  services: {
    title: string
    description: string
  }
}

export interface RouteSeoMeta {
  title: string
  description: string
}

export interface RouteMetaConfig extends RouteSeoMeta {
  robots: string
}

type SeoRouteEntry = {
  title: string
  description: string
  robots: string
  urlPath?: string
  routerSeo?: boolean
  selfManagedSeo?: boolean
}

/** Titre accueil / défaut (~56 car. — recommandation SEO 50–60) */
export const defaultSiteTitle = seoRoutes.routes.home.title

export const seoTranslations: Record<string, SeoConfig> = {
  fr: {
    title: defaultSiteTitle,
    description: seoRoutes.defaultSiteDescription,
    keywords:
      'développement web, développement mobile, création site web, application mobile, agence digitale, France',
    organization: {
      name: 'PostDev',
      description: 'Votre partenaire en développement web et mobile'
    },
    services: {
      title: 'Nos Services de Développement',
      description: 'Services professionnels de développement web et mobile'
    }
  }
}

/** Meta SEO par route publique (monolingue) — dérivé de seo.routes.json. */
export const routeSeoTranslations: Record<string, RouteSeoMeta> = Object.fromEntries(
  Object.entries(seoRoutes.routes as Record<string, SeoRouteEntry>)
    .filter(([, meta]) => meta.routerSeo === true)
    .map(([name, meta]) => [name, { title: meta.title, description: meta.description }])
)

export function getRouteMetaFromConfig(routeName: string): RouteMetaConfig | null {
  const entry = (seoRoutes.routes as Record<string, SeoRouteEntry>)[routeName]
  if (!entry) return null
  return {
    title: entry.title,
    description: entry.description,
    robots: entry.robots
  }
}

export function isSelfManagedSeoRoute(routeName: string): boolean {
  if (routeName === 'local-city-hub' || routeName.startsWith('local-svc-')) {
    return true
  }
  const entry = (seoRoutes.routes as Record<string, SeoRouteEntry>)[routeName]
  return entry?.selfManagedSeo === true
}

export function getRouteSeoMeta(routeName: string, _locale: string): RouteSeoMeta | null {
  const baseRouteName = routeName.replace(/-(?:en|es|de|it|pt|nl|pl)$/, '')
  return routeSeoTranslations[baseRouteName] ?? null
}
